import {GoogleDriveAccessToken} from "@/utils/GoogleDriveAccessToken.util";


class FilePickerCredentialsClass {

	/**
	 * Destroy all credentials the file pickers keep in the browser.
	 */
	clear() {

		GoogleDriveAccessToken.clear();

		// OneDrive: MSAL caches the Microsoft account and its tokens in sessionStorage (its default
		// cacheLocation). Its keys have no stable prefix, so wipe the whole (tab scoped) storage.
		sessionStorage.clear();

	}

}

const FilePickerCredentials = new FilePickerCredentialsClass();

export {
	FilePickerCredentials
};
